
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(1160|4175|9121|9857)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
